import { AuthService } from 'src/auth/auth.service';
import { DentallyWizardService } from './components/wizards/dentally/dentally-wizard.service';
import { AmplitudeService } from './../services/amplitude-service';
import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {


  public ShowForm: boolean = true;
 
  constructor(private authService:AuthService, private amplitude:AmplitudeService, private dentallyService: DentallyWizardService, private router:Router) {}

  ngOnInit() {

    this.authService.getClaims$().subscribe((claims) => {
      if(!claims) return;
      this.dentallyService.getWizardState().subscribe(
        (response) => {
          this.dentallyService.initDentallyButtonLocalStorage();
          this.dentallyService.removeButtonFromLocalStorage();
          if (response.complete) {
            return;
          }
          this.dentallyService.activateLaunchButton()
          if (this.router.url.includes("dentally/callback") === false) {
            this.router.navigate([
              `/wizard/${response.type.toLowerCase()}/connect`,
            ]);
          }
        },
        (err) => {
          console.log(err);
        }
      );
    });   
  }
  
  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent) {
    this.amplitude.logClickEvent(event);
  }
}
